import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';
import { Badge } from './ui/badge';
import { Heart, HeartCrack, Gauge } from 'lucide-react';
import { getApiUrl } from '../utils/api';

const API_URL = getApiUrl();

/**
 * MM audit 3.5: DEX health monitor UI.
 *
 * Live показывает up/down + latency для Omniston (STON.fi) и DeDust.
 * Не блокирует swap pipeline — мониторинг для оператора.
 */
const DexHealthCard = () => {
  const [status, setStatus] = useState(null);

  const load = async () => {
    try {
      const s = await fetch(`${API_URL}/api/market-maker/dex-health`).then(r => r.json());
      setStatus(s);
    } catch (e) {
      // silent
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const last = status?.last || {};
  const dexes = ['omniston', 'dedust'];

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2">
          <Gauge className="h-4 w-4" /> DEX Health
          <Badge variant="outline" className="text-xs">
            check every {status?.interval_seconds || '?'}s
          </Badge>
        </CardTitle>
        <CardDescription className="text-xs">
          Live проверка доступности STON.fi Omniston и DeDust. Если Omniston
          лежит — swap pipeline встаёт (BUYT на DeDust пока нет, fallback
          будет готов при появлении).
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {dexes.map((d) => {
            const info = last[d] || {};
            const up = !!info.up;
            return (
              <div key={d} className={`p-3 rounded border ${up ? 'border-emerald-500/30 bg-emerald-500/5' : 'border-red-500/30 bg-red-500/5'}`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    {up ? (
                      <Heart className="h-4 w-4 text-emerald-400" />
                    ) : (
                      <HeartCrack className="h-4 w-4 text-red-400" />
                    )}
                    <span className="font-medium">{d.toUpperCase()}</span>
                  </div>
                  <Badge className={up ? 'bg-emerald-600' : 'bg-red-600'}>
                    {up ? 'UP' : 'DOWN'}
                  </Badge>
                </div>
                <div className="text-xs text-slate-400 mt-2 space-y-1">
                  <div>Latency: <span className="text-slate-200">{info.latency_sec ?? '—'}s</span></div>
                  {info.error && <div className="text-red-400">Error: {info.error}</div>}
                  {info.checked_at && <div>Checked: {info.checked_at.slice(11, 19)} UTC</div>}
                  {info.ask_units != null && (
                    <div>Quote: {(info.ask_units / 1e9).toFixed(6)} received</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default DexHealthCard;
